/**
 * 登出弹出层
 */

import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import lang from '../../lang/index';
import logoutpb from './logout.pb';
import publicpb from '../../base/public.pb';
import PbAjax from '../../lib/pbajax';
import Modal from 'boron/ScaleModal';

let pbajax = new PbAjax();

const noop = function(){};

const style = {
    modalStyle: {
         width: '320px'
    },
    contentStyle: {
        width: '320px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
}

class LogoutPop  extends Component {
    static defaultProps = {
        onHide: noop
    }
    constructor(props){
        super(props);
    }

    componentDidMount() {
        this.refs.modal.show();
    }

    onConfirm() {
        this.logout();
    }
    onCancel() {
        this.refs.modal.hide();
    }

    logout(){
        let { Request, Response } = logoutpb.UserLogout;
        let cfg = {
            service: 'safe',
            api: '/user/logout',
            header: {
                userToken: UP.Global.getUserToken()
            }
        };
        
        pbajax.do(cfg, new Request({}), (res)=>{
            let dataWrap = publicpb.Result.decode(res);
            
            if (dataWrap.code == 1){
                // 登出成功
                this.onCancel();
                window.hashHistory.push('/home');
                $.channel.emit('logout');
            }
        }, ()=>{
            
        }, ()=>{
        });
    }

    render() {
        return (
            <Modal 
                ref="modal" 
                modalStyle={style.modalStyle}  
                backdropStyle={style.backdropStyle} 
                contentStyle={style.contentStyle}
            >
                <div className="logout-pop">
                    <div className="logout-pop-hd">{lang.template('提示')}</div>
                    <div className="logout-pop-bd">{lang.template('确认退出Up直播？')}</div>
                    <div className="logout-pop-ft">
                        <button className="btn cancel" onClick={()=>this.onCancel()}>{lang.template('取消')}</button>
                        <button className="btn confirm" onClick={()=>this.onConfirm()}>{lang.template('确认')}</button>
                    </div>
                </div>
            </Modal>
        );
    }
}


module.exports = {
    create: function (cfg) {
        cfg = cfg || {};
        
        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();
        
        this.layer = ReactDOM.render(
            <LogoutPop {...cfg} onHide={this.onHide.bind(this)}/>,
            mountNode
        );
    },
    onHide: function(){
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy : function () {
        ReactDOM.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};


// WEBPACK FOOTER //
// ./js/component/logout/index.js